import { Season } from '@/types/vod/VodItemDetails'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { Box, Typography, useTheme } from '@mui/material'
import { isSmartTV } from '@/shared/lib'

// Child component for each focusable season
export const FocusableSeason = ({
    season,
    handleSelectSeason,
    setSeasonBackgroundColor,
    setSeasonTextColor,
}: {
    season: Season
    handleSelectSeason: (season: Season) => void
    setSeasonBackgroundColor: (season: Season) => string
    setSeasonTextColor: (season: Season) => string
}) => {
    const { ref, focused } = useFocusable({
        focusKey: `season-${season.id}`,

        onEnterPress: () => {
            handleSelectSeason(season)
        },
    })

    const theme = useTheme()

    const seasonLabelStyle = {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '75px',
        height: '60px',
        padding: '16px',
        borderRadius: theme.shape.borderRadius,
    }

    return (
        <Box
            ref={ref}
            onClick={() => handleSelectSeason(season)}
            sx={{
                ...seasonLabelStyle,
                backgroundColor: setSeasonBackgroundColor(season),
                outline: focused && isSmartTV() ? '2px solid yellow' : 'none', // Visual indicator when focused
            }}>
            <Typography
                role="span"
                color={() => setSeasonTextColor(season)}
                variant="headline3">
                {season.seasonNo}
            </Typography>
        </Box>
    )
}
